import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Markets from "./pages/Markets";
import Trade from "./pages/Trade";
import Deposit from "./pages/Deposit";
import Withdraw from "./pages/Withdraw";
import History from "./pages/History";
import Support from "./pages/Support";
import Admin from "./pages/Admin";
import BinaryTrade from "./pages/BinaryTrade";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  // While the very first /auth/me is in-flight, show a loader instead of
  // redirecting. This is what makes refresh-on-protected-route persist.
  if (loading || user === undefined) {
    return (
      <div
        style={{ padding: 60, textAlign: "center" }}
        className="text-dim"
        data-testid="auth-loading"
      >
        Loading…
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function RootRoute() {
  const { user, loading } = useAuth();
  if (loading || user === undefined) {
    return (
      <div style={{ padding: 60, textAlign: "center" }} className="text-dim" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Landing />;
}

function Shell() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<RootRoute />} />
        <Route path="/markets" element={<Markets />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        {/* Legacy admin login URL → redirect to unified login */}
        <Route path="/admin/login" element={<Navigate to="/login" replace />} />
        <Route path="/trade" element={<ProtectedRoute><Trade /></ProtectedRoute>} />
        <Route path="/deposit" element={<ProtectedRoute><Deposit /></ProtectedRoute>} />
        <Route path="/withdraw" element={<ProtectedRoute><Withdraw /></ProtectedRoute>} />
        <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
        <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
        <Route path="/trading" element={<ProtectedRoute><BinaryTrade /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}
